import { Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/bunadstuggu-logo-white.png";

const Footer = () => {
  return (
    <footer className="bg-charcoal text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <h3 className="font-serif text-xl mb-4">Bunadstuggu</h3>
            <p className="text-white/60 font-sans text-sm leading-relaxed max-w-md mb-6">
              Vi er opptatt av å bringe gode bunadstradisjoner videre. 
              Alle våre bunader er norskprodusert, og vi bruker kun norske materialer.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-white/40 hover:bg-white/5 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-white/40 hover:bg-white/5 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg mb-4">Snarveier</h4>
            <nav aria-label="Snarveier" className="flex flex-col gap-3">
              <a href="#" className="text-white/60 hover:text-white transition-colors font-sans text-sm">
                Forside
              </a>
              <a href="#historie" className="text-white/60 hover:text-white transition-colors font-sans text-sm">
                Historie
              </a>
              <a href="#drakter" className="text-white/60 hover:text-white transition-colors font-sans text-sm">
                Våre drakter
              </a>
              <a href="#tilbehor" className="text-white/60 hover:text-white transition-colors font-sans text-sm">
                Tilbehør
              </a>
              <a href="#kontakt" className="text-white/60 hover:text-white transition-colors font-sans text-sm">
                Kontakt
              </a>
              <Link to="/sporsmal" className="text-white/60 hover:text-white transition-colors font-sans text-sm">
                Spørsmål
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg mb-4">Kontakt</h4>
            <address className="not-italic text-white/60 font-sans text-sm space-y-3">
              <p>Kirkegata 38<br />7600 Levanger</p>
              <p>Tlf: 480 09 271</p>
            </address>
            <div className="mt-4 pt-4 border-t border-white/10">
              <p className="text-white/40 font-sans text-xs">
                Man–Ons: 09.30–16.30<br />
                Tors: 09.30–18.00<br />
                Fre: 09.30–16.30<br />
                Lør: 09.30–14.00
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col items-center gap-3">
          <img 
            src={logo} 
            alt="Bunadstuggu" 
            className="h-10 lg:h-12 w-auto"
          />
          {/* Norwegian flag accent */}
          <div className="flex items-center gap-2 mt-1" aria-hidden="true">
            <div className="h-[2px] w-8 bg-[hsl(0,70%,45%)]" />
            <div className="h-[2px] w-3 bg-[hsl(216,80%,30%)]" />
            <div className="h-[2px] w-3 bg-white/60" />
            <div className="h-[2px] w-3 bg-[hsl(216,80%,30%)]" />
            <div className="h-[2px] w-8 bg-[hsl(0,70%,45%)]" />
          </div>
          <p className="text-white/70 font-sans text-sm tracking-widest uppercase">Produsert i Norge</p>
          <p className="text-white/40 font-sans text-xs mt-2">
            © {new Date().getFullYear()} Bunadstuggu. Alle rettigheter reservert.
          </p>
          <div className="flex items-center gap-4 mt-4">
            <Link 
              to="/personvern" 
              className="text-white/40 hover:text-white/70 font-sans text-xs transition-colors"
            >
              Personvernerklæring
            </Link>
            <span className="text-white/20">|</span>
            <Link 
              to="/auth" 
              className="text-white/30 hover:text-white/60 font-sans text-xs transition-colors"
            >
              Logg inn
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
